<app-navbar>
  <app-user-action></app-user-action>
</app-navbar>
<div class="ui container search-results-container">
  <h2>Search Results for "{{query}}"</h2>
  @if (results) {
    <div class="ui six doubling cards">
      @for (item of results; track item) {
        <div class="card item-card">
          <a class="image" [routerLink]="['/item', item.id]">
            @if (item.coverImage) {
              <ui-responsive-image [src]="item.coverImage.url"
                             [size]="{
                                    width: '100%',
                                    ratio: 1.405152224824,
                                    originalWidth: item.coverImage.width,
                                    originalHeight: item.coverImage.height}"
              [background]="item.coverImage.dormantColor"></ui-responsive-image>
            }
          </a>
          <a class="content" [routerLink]="['/item', item.id]">
            <span>{{item.name_cn || item.name || ' '}}</span>
          </a>
        </div>
      }
    </div>
  }
  @if (!results || results.length === 0) {
    <div>
      No results found.
    </div>
  }
</div>
